import { notification } from "antd"
import { type ArgsProps } from "antd/lib/notification"

import {
  configNotification,
  notificationOptions
} from "../../constants/notification.config"

export const showNotification = {
  success: (config: ArgsProps) =>
    notification.success({
      ...config,
      ...notificationOptions.success
    }),

  info: (config: ArgsProps) =>
    notification.info({
      ...config,
      ...notificationOptions.info
    }),

  error: (config: ArgsProps) =>
    notification.error({
      ...config,
      ...notificationOptions.error
    }),

  warning: (config: ArgsProps) =>
    notification.warning({
      ...config,
      ...notificationOptions.warning
    }),

  open: (config: ArgsProps) =>
    notification.open({
      ...config,
      ...configNotification
    }),

  destroy: (key: string) => notification.destroy(key)
}
